import {
    Component,
    EventEmitter,
    Input, Output, TemplateRef, ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { SubscriptionModel } from '../../../../../shared/models/subscription.model';
import { ClientModel } from '../../../../../shared/models/client.model';
import { CommonHttpService } from '../../../../../shared/services/http.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Response } from '@angular/http';
import { OverlayContext } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';

@Component({
    selector: 'account-subscriptions-details-actions-auto-renew',
    templateUrl: './account.subscriptions.details.actions.auto-renew.component.html',
    styleUrls: ['./../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsActionsAutoRenewComponent {
    static INTENT_DISABLE = 0;
    static INTENT_ENABLE = 1;

    @Input('client') client: ClientModel;
    @Input('subscription') subscription: SubscriptionModel;
    @Input('enabledAutoRenew') enabledAutoRenew: boolean;
    @Output('loading') loading: EventEmitter<null> = new EventEmitter();
    @Output('updated') updated: EventEmitter<null> = new EventEmitter();
    @Output('failed') failed: EventEmitter<null> = new EventEmitter();

    @ViewChild('templateRef') public templateRef: TemplateRef<any>;
    protected overlayContext = new OverlayContext();
    protected intent;

    constructor(
        protected modal: Modal,
        protected http: CommonHttpService,
        protected translate: TranslateService,
        protected toastr: ToastrService
    ) { }

    /**
     * Open dialog to input payment method data.
     **/
    public openDialog() {
        this.modal.open(this.templateRef, {context: this.overlayContext});
    }
    /**
     * Call API to disable subscription's auto_renew property.
     * */
    public disableAutoRenew() {
        this.intent = AccountSubscriptionsDetailsActionsAutoRenewComponent.INTENT_DISABLE;
        this.openDialog();
    }
    /**
     * Call API to enable subscription's auto_renew property.
     * */
    public enableAutoRenew() {
        this.intent = AccountSubscriptionsDetailsActionsAutoRenewComponent.INTENT_ENABLE;
        this.openDialog();
    }
    /**
     * Call API to update subscription data.
     **/
    public save(dialogRef: any) {
        this.updateAutoRenew(!!this.intent);
        this.closeDialog(dialogRef);
    }
    /**
     * Base to call API endpoint to update auto_renew property.
     * */
    private updateAutoRenew(autoRenew: boolean) {
        this.loading.emit();

        this.translate.get([
            'ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.AUTO_RENEW_UPDATE.SUCCESS',
            'ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.AUTO_RENEW_UPDATE.ERROR'
        ]).subscribe(translated => {
            return this.http.useAuth().put(
                `/account/clients/${this.client.id}`
                + `/subscriptions/${this.subscription.id}`,
                {'auto_renew': autoRenew}
            ).subscribe((response: Response) => {
                this.enabledAutoRenew = response.json().data.auto_renew;

                this.updated.emit();
                this.toastr.success(translated['ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.AUTO_RENEW_UPDATE.SUCCESS']);
            }, () => {
                this.failed.emit();
                this.toastr.error(translated['ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.AUTO_RENEW_UPDATE.ERROR']);
            });
        });
    }
    /**
     * Close dialog.
     **/
    public closeDialog(dialogRef: any) {
        dialogRef.close();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/account/subscriptions/details/actions/auto-renew/account.subscriptions.details.actions.auto-renew.component.ts